"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getGoogleIdToken = void 0;
var getGoogleIdToken = function getGoogleIdToken(identity) {
  return identity === null || identity === void 0 ? void 0 : identity.googleIdToken;
};
exports.getGoogleIdToken = getGoogleIdToken;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJnZXRHb29nbGVJZFRva2VuIiwiaWRlbnRpdHkiLCJnb29nbGVJZFRva2VuIiwiZXhwb3J0cyJdLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9zZWxlY3RvcnMvZ29vZ2xlLWlkLXRva2VuLmpzIl0sInNvdXJjZXNDb250ZW50IjpbImV4cG9ydCBjb25zdCBnZXRHb29nbGVJZFRva2VuID0gKGlkZW50aXR5KSA9PiBpZGVudGl0eT8uZ29vZ2xlSWRUb2tlbjtcbiJdLCJtYXBwaW5ncyI6Ijs7Ozs7O0FBQU8sSUFBTUEsZ0JBQWdCLEdBQUcsU0FBbkJBLGdCQUFnQkEsQ0FBSUMsUUFBUTtFQUFBLE9BQUtBLFFBQVEsYUFBUkEsUUFBUSx1QkFBUkEsUUFBUSxDQUFFQyxhQUFhO0FBQUE7QUFBQ0MsT0FBQSxDQUFBSCxnQkFBQSxHQUFBQSxnQkFBQSJ9